// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"54358eda","413":"3da69a65","625":"43df4d5c","789":"9da0fddf"}[chunkId] + ".chunk.css";
};